import axios from 'axios';
import {AXIOS_CONFIG_IP_BLOCK, API_CONFIGS, AXIOS_CONFIG_PDA_IP_BLOCK, AXIOS_CONFIG_PDA_MEMBERSHIPS_INTEGRATION} from '../configs';
import { ACTIONS } from './index';

export function ipBlock(postId, data) {
    const axiosInstance = axios.create(AXIOS_CONFIG_IP_BLOCK());
    const request = axiosInstance.post(`${API_CONFIGS.IP_BLOCK(postId)}`, data);

    return {
        type: ACTIONS.IP_BLOCK,
        payload: request
    }
}

export function getIpBlock(postId) {
    const axiosInstance = axios.create(AXIOS_CONFIG_IP_BLOCK());
    const request = axiosInstance.get(`${API_CONFIGS.GET_IP_BLOCK(postId)}`, {
        timeout: 10000
    });

    return {
        type: ACTIONS.GET_IP_BLOCK,
        payload: request
    }
}

export function getUserRolesIpBlock(postId) {
    // const axiosInstance = axios.create(AXIOS_CONFIG_IP_BLOCK());
    // const request = axiosInstance.get(`${API_CONFIGS.GET_USER_ROLES_IP_BLOCK(postId)}`, {
    //     timeout: 10000
    // });

    if (typeof(ip_block_server_data) !== "undefined" && ip_block_server_data.ip_block_activated == -1) {
        var axiosInstance = axios.create(AXIOS_CONFIG_IP_BLOCK());
        var request = axiosInstance.get(`${API_CONFIGS.GET_USER_ROLES_IP_BLOCK(postId)}`, {
            timeout: 10000
        });
    } else {
        var axiosInstance = axios.create(AXIOS_CONFIG_PDA_IP_BLOCK());
        var request = axiosInstance.get(`${API_CONFIGS.PDA_GET_FILE_ACCESS_PERMISSIONS(postId)}`, {
            timeout: 10000
        });
    }

    return {
        type: ACTIONS.GET_USER_ROLES_IP_BLOCK,
        payload: request
    }
}

export function addUserRoles(postId, data) {
    const axiosInstance = axios.create(AXIOS_CONFIG_PDA_IP_BLOCK());
    const request = axiosInstance.post(`${API_CONFIGS.PDA_ADD_USER_ROLES(postId)}`, data);

    return {
        type: ACTIONS.ADD_USER_ROLES,
        payload: request
    }
}

export function getAllUserRoles(data) {
    const axiosInstance = axios.create(AXIOS_CONFIG());
    const request = axiosInstance.get(`${API_CONFIGS.GET_ALL_USER_ROLES}`, data);

    return {
        type: ACTIONS.GET_ALL_USER_ROLES,
        payload: request
    }
}

// export function getIpBlockSetting(data) {
//     const axiosInstance = axios.create(AXIOS_CONFIG_PDA_IP_BLOCK());
//     const request = axiosInstance.get(`${API_CONFIGS.GET_IP_BLOCK_SETTING}`, data);
//     return {
//         type: ACTIONS.GET_IP_BLOCK_SETTING,
//         payload: request
//     }
// }

export function getMembersSelect(postId, data) {
    const axiosInstance = axios.create(AXIOS_CONFIG_PDA_MEMBERSHIPS_INTEGRATION());
    const request = axiosInstance.get(`${API_CONFIGS.GET_MEMBERS_SELECT(postId)}`, data);
    return {
        type: ACTIONS.GET_MEMBERS_SELECT,
        payload: request
    }
}
